"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faUserCircle_1 = require("@fortawesome/pro-light-svg-icons/faUserCircle");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var ProfileAvatar_1 = __importDefault(require("atomicComponents/molecules/Image/ProfileAvatar"));
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var reviews_1 = require("utils/reviews");
var Rating_1 = __importDefault(require("../Rating"));
var ServiceStatsSummaryWrapper = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        marginTop: theme.spacing(4),
        display: 'flex',
        alignItems: 'center',
        '& .MuiBox-root > span': {
            fontSize: theme.typography.body1.fontSize,
        },
    });
});
var ToolStatsSummary = function (_a) {
    var _b, _c;
    var toolStats = _a.toolStats, reviews = _a.reviews;
    var numLicenses = (0, reviews_1.countLicenses)(reviews || []).totalLicenses;
    return ((0, jsx_runtime_1.jsx)(ServiceStatsSummaryWrapper, { children: [
            { key: 'spend', elem: (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: toolStats.calculatedAnnualSpend }), " Last 12 Months"] })) },
            { key: 'rate', elem: toolStats.avgRating && (0, jsx_runtime_1.jsx)(Rating_1.default, { rating: 3, ratingsCount: reviews === null || reviews === void 0 ? void 0 : reviews.filter(function (r) { return r === null || r === void 0 ? void 0 : r.rating; }).length }) },
            {
                key: 'licenses',
                elem: !!numLicenses && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faUserCircle_1.faUserCircle }), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, ml: 1 }, { children: [numLicenses, " licenses"] }))] }),
            },
            {
                key: 'companyTeams',
                elem: ((_b = toolStats.companyTeams) === null || _b === void 0 ? void 0 : _b.length) && (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (_c = toolStats.companyTeams) === null || _c === void 0 ? void 0 : _c.map(function (t) { return t.name; }).join(' • ') })),
            },
            { key: 'owner', elem: toolStats.owner && (0, jsx_runtime_1.jsx)(ProfileAvatar_1.default, { size: "sm", profile: toolStats.owner }) },
        ].filter(function (_a) {
            var elem = _a.elem;
            return elem;
        }).map(function (_a, idx, arr) {
            var key = _a.key, elem = _a.elem;
            return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [elem, idx !== arr.length - 1 && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mx: 1 }, { children: "\u00B7" }))] }, key));
        }) }));
};
exports.default = ToolStatsSummary;
